<template>
  <VContainer class="contact-us-page">
    <VRow>
      <VCol cols="12" md="3">
        <div class="contact">
          <div class="contact__title">
            Sales Office: <br />
            New York, USA
          </div>
          <div class="contact__map">
            <img src="@/assets/contact-usa.png" />
          </div>
          <div class="contact__phone">Tel: <a href="tel:+18882285916">+18882285916</a></div>
          <div class="contact__open">(Toll Free) - Open 24/7</div>
          <div class="contact__address">
            2578 Broadway #588 <br />
            New York, NY <br />
            10025-8844USA
          </div>
        </div>
      </VCol>
      <VCol cols="12" md="3">
        <div class="contact">
          <div class="contact__title">
            Head Office: <br />
            Galway, Ireland
          </div>
          <div class="contact__map">
            <img src="@/assets/contact-ireland.png" />
          </div>
          <div class="contact__phone">Tel: <a href="tel:+353091335583">+353091335583</a></div>
          <div class="contact__open">Open Mon-Fri Office Hours</div>
          <div class="contact__address">
            Gray Office Park <br />
            Headford Road <br />
            Galway, H91 WC1P <br />
            Ireland<br />
          </div>
        </div>
      </VCol>
      <VCol cols="12" md="3">
        <div class="contact">
          <div class="contact__title">
            Sales Office: <br />
            Sydney, Australia
          </div>
          <div class="contact__map">
            <img src="@/assets/contact-usa.png" />
          </div>
          <div class="contact__phone">Tel: <a href="tel:+611300339559">+611300339559</a></div>
          <div class="contact__open">Open 24/7</div>
          <div class="contact__address">
            1/457-459 Elizabeth St <br />
            Surry Hills <br />
            NSW 2010 <br />
            Australia
          </div>
        </div>
      </VCol>
      <VCol cols="12" md="3">
        <div class="contact">
          <div class="contact__title">
            Sales Office: <br />
            South Africa
          </div>
          <div class="contact__map">
            <img src="@/assets/contact-usa.png" />
          </div>
          <div class="contact__phone">Tel: <a href="tel:+27211096873">+27211096873</a></div>
          <div class="contact__open">Open Mon-Fri Office Hours</div>
          <div class="contact__address">
            101 Masons Press Annex, <br />
            5 Ravenscraig Rd, <br />
            Cape Town, Woodstock, 7925, <br />
            South Africa
          </div>
        </div>
      </VCol>
      <VCol>
        <div class="note my-5">
          <span class="text-red-color">NOTE:</span> We're an online business dealing with customers globally so do not
          accept drop-in visits to the office.
        </div>
      </VCol>
    </VRow>
    <VRow>
      <div class="form">
        <VForm v-model="formValid" @submit.prevent>
          <VRow>
            <VCol cols="12">
              <div class="form__title">Get in Touch</div>
            </VCol>
            <VCol cols="12">
              <VSelect
                label="Subject"
                variant="outlined"
                color="primary"
                name="subject"
                :rules="formRules.subject"
                v-model="form.subject"
                placeholder="Enter"
                :disabled="isLoadingForm"
                prepend-inner-icon="mdi-text"
                :items="subjectOptions"
              >
              </VSelect>
            </VCol>
            <VCol cols="12">
              <VTextarea
                label="Message"
                v-model="form.message"
                variant="outlined"
                prepend-inner-icon="mdi-text"
                :maxlength="255"
                :disabled="isLoadingForm"
              ></VTextarea>
            </VCol>
            <VCol cols="12">
              <VBtn :loading="isLoadingForm" type="submit" color="primary" block flat @click="handleSubmit()"
                >Submit</VBtn
              >
            </VCol>
          </VRow>
        </VForm>
      </div>
    </VRow>
  </VContainer>
</template>
<script>
import { mapActions } from 'vuex';
//Service
import applicationService from '@/services/application-service/application.service';
export default {
  name: 'ContactUsPage',
  components: {},
  data() {
    return {
      isLoadingForm: false,
      formValid: false,
      formRules: {
        subject: [(v) => !!v || 'Subject required'],
        message: [(v) => !!v || 'Message required']
      },
      form: {
        subject: 'Reapply pre-2027 to buy Future Years',
        message: ''
      },
      subjectOptions: [
        'Reapply pre-2027 to buy Future Years',
        'My Parents / Other (75+) Worked in UK',
        'Check if HMRC Got My Payment',
        'Check if HMRC Allocated Payment Correctly',
        'My Old Work / Private UK Pension - Query',
        'Billing Query',
        'General Enquiry'
      ]
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar']),
    async handleSubmit() {
      if (this.formValid === true) {
        this.isLoadingForm = true;
        try {
          await applicationService.createNotes(this.form);
          this.showSnackbar({ text: 'Message successfully sent', color: 'green' });
          this.resetForm();
        } catch (err) {
          console.error(err);
          this.showSnackbar({ text: err?.message || 'Oops, Something Went Wrong', color: 'red' });
        } finally {
          this.isLoadingForm = false;
        }
      }
    },
    resetForm() {
      this.form = {
        subject: 'Reapply pre-2027 to buy Future Years',
        message: ''
      };
    }
  }
};
</script>
